package org.ksdfv.thelema.mesh

import org.ksdfv.thelema.data.IByteData
import kotlin.native.concurrent.ThreadLocal

@ThreadLocal
object MESH: IMeshProvider {
    var proxy: IMeshProvider = object : IMeshProvider{
        override fun mesh(): IMesh = Mesh()
        override fun vertexBuffer(bytes: IByteData, vertexInputs: IVertexInputs, initGpuObjects: Boolean): IVertexBuffer =
            VertexBufferObject(bytes, vertexInputs, initGpuObjects = initGpuObjects)

        override fun indexBuffer(bytes: IByteData, type: Int, initGpuObjects: Boolean): IIndexBufferObject =
            IndexBufferObject(bytes, type, initGpuObjects = initGpuObjects)

        override fun vertexInputs(vararg inputs: VertexInput): IVertexInputs =
            VertexInputs(*inputs)

        override fun vertexInput(size: Int, name: String, type: Int, normalized: Boolean): IVertexInput =
            VertexInput(size, name, type, normalized)

        override fun screenQuad(): IScreenQuad = ScreenQuad()
    }

    override fun mesh(): IMesh = proxy.mesh()
    override fun vertexBuffer(bytes: IByteData, vertexInputs: IVertexInputs, initGpuObjects: Boolean): IVertexBuffer =
        proxy.vertexBuffer(bytes, vertexInputs, initGpuObjects)

    override fun indexBuffer(bytes: IByteData, type: Int, initGpuObjects: Boolean): IIndexBufferObject =
        proxy.indexBuffer(bytes, type, initGpuObjects)

    override fun vertexInputs(vararg inputs: VertexInput): IVertexInputs =
        proxy.vertexInputs(*inputs)

    override fun vertexInput(size: Int, name: String, type: Int, normalized: Boolean): IVertexInput =
        proxy.vertexInput(size, name, type, normalized)

    override fun screenQuad(): IScreenQuad = proxy.screenQuad()
}